var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "i/checked") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-4---UI",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "AU1.5",
    transform: "translate(-40.000000, -134.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Screen",
    transform: "translate(24.000000, 118.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "i/checked",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#32BA7C",
    cx: 16,
    cy: 16,
    r: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9116719,23.2176656 L20.1388013,31.444795 C26.9526814,29.6277603 32,23.4195584 32,16 C32,15.8485804 32,15.6971609 32,15.5457413 L25.5394322,9.58990536 L11.9116719,23.2176656 Z",
    id: "Path",
    fill: "#0AA06E"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(5.375394, 7.899054)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0283912,11.6845426 C11.7350158,12.3911672 11.7350158,13.6025237 11.0283912,14.3091483 L9.56466877,15.7728707 C8.85804416,16.4794953 7.6466877,16.4794953 6.94006309,15.7728707 L0.529968454,9.31230284 C-0.176656151,8.60567823 -0.176656151,7.39432177 0.529968454,6.68769716 L1.99369085,5.22397476 C2.70031546,4.51735016 3.91167192,4.51735016 4.61829653,5.22397476 L11.0283912,11.6845426 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6309148,0.529968454 C17.3375394,-0.176656151 18.5488959,-0.176656151 19.2555205,0.529968454 L20.7192429,1.99369085 C21.4258675,2.70031546 21.4258675,3.91167192 20.7192429,4.61829653 L9.61514196,15.6719243 C8.90851735,16.3785489 7.69716088,16.3785489 6.99053628,15.6719243 L5.52681388,14.2082019 C4.82018927,13.5015773 4.82018927,12.2902208 5.52681388,11.5835962 L16.6309148,0.529968454 Z",
    id: "Path"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.f2ff653604d3de8cfcd347f270ad697f.svg";
export { ForwardRef as ReactComponent };